<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/mainContent/newsList' }"
          >新闻列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">新闻详情</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-4 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">详情</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form class="font-weight-bold" :model="newsInfo" label-width="120px">
          <el-form-item label="新闻标题">
            <el-input v-model="newsInfo.newsTitle"></el-input>
          </el-form-item>
          <el-form-item label="新闻封面">
            <el-input
              v-model="newsInfo.newsCover"
              autocomplete="off"
              placeholder="新闻封面URL"
            >
            </el-input>

            <div class="d-flex">
              <img-upload
                @onUpload="uploadImg"
                ref="newsCoverUpload"
              ></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸170*130像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail"
                :src="newsInfo.newsCover"
                :preview-src-list="[newsInfo.newsCover]"
              />
            </div>
          </el-form-item>
          <el-form-item label="是否发布">
            <el-radio-group v-model="newsInfo.newsStatus">
              <el-radio :label="true" border>是</el-radio>
              <el-radio :label="false" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="首页展示">
            <el-radio-group v-model="newsInfo.homeShow">
              <el-radio :label="true" border>是</el-radio>
              <el-radio :label="false" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="新闻标签">
            <el-radio-group v-model="newsInfo.newsTag">
              <el-radio :label="0" border>无</el-radio>
              <el-radio :label="1" border>hot</el-radio>
              <el-radio :label="2" border>置顶</el-radio>
              <el-radio :label="3" border>推荐</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="访问量">
            <el-input v-model="newsInfo.newsViews"></el-input>
          </el-form-item>
          <el-form-item label="新闻内容" class="m-0"></el-form-item>
          <el-form-item label-width="0">
            <my-editor v-model="newsInfo.newsContent"></my-editor>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitNewsForm(newsInfo)"
              >立即提交
            </el-button>
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import ImgUpload from "../../components/common/ImgUpload";
import MyEditor from "../../components/common/MyEditor";
export default {
  name: "NewsForm",
  data() {
    return {
      newsId: this.$route.params.newsId,
      newsInfo: {
        newsCover: ""
      }
    };
  },
  components: {
    ImgUpload,
    MyEditor
  },
  mounted() {
    if (this.newsId !== 0) {
      this.getNewsById();
    }
  },
  methods: {
    getNewsById() {
      this.axios
        .get("/news/getNewsById", {
          params: {
            newsId: this.newsId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.newsInfo = resp.data.data;
          }
        });
    },
    uploadImg() {
      this.newsInfo.newsCover = this.$refs.newsCoverUpload.url;
    },
    cancelSubmitForm() {
      this.$router.push({ name: "NewsList" }).catch();
    },
    submitNewsForm(newsInfo) {
      this.axios
        .post("/news/admin/addOrUpdateNews", {
          newsId: newsInfo.newsId,
          newsTitle: newsInfo.newsTitle,
          newsCover: newsInfo.newsCover,
          newsStatus: newsInfo.newsStatus,
          newsTag: newsInfo.newsTag,
          newsViews: newsInfo.newsViews,
          homeShow: newsInfo.homeShow,
          newsContent: newsInfo.newsContent
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "NewsList" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
